import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { TokenTypeButton } from "../shared/TokenTypeButton";
import { PARAGRAPH_LEVELS } from "./constants";

export const Paragraphs = () => {
  const toggleSidebarView = useBuilderStore(state => state.toggleSidebarView);

  return (
    <>
      {PARAGRAPH_LEVELS.map(paragraph => (
        <TokenTypeButton
          key={paragraph.value}
          tokenType={paragraph}
          onClick={() => toggleSidebarView(paragraph.actionView)}
        />
      ))}
    </>
  );
};
